 const CONFIG = {
   BASE_API_URL: getBackendUrl(),
   BASE_AZURE_TENANT_NAME: getB2CTenantName(),
   BASE_AZURE_TENANT_CLIENT_ID: getB2CTenantClient(),
   VUE_APP_AZURE_SIGN_IN_FLOW: getB2cPolicyNames().sign_in,
   VUE_APP_AZURE_PASSWORD_FLOW: getB2cPolicyNames().password,
   VUE_APP_AZURE_PROFILE_FLOW: getB2cPolicyNames().profile,
   VUE_APP_AZURE_CHANGE_PASSWORD_FLOW: getB2cPolicyNames().change_password,
 };

 function getBackendUrl () {
   if (window.location.hostname.startsWith('timesheet.hays') || window.location.hostname.startsWith('vendor.hays')
   || window.location.hostname.startsWith('vatholder.timesheet.hays')|| window.location.hostname.startsWith('timesheet-temp.hays')) {
     return process.env.VUE_APP_API_URL_PROD;
   } else {
     return process.env.VUE_APP_API_URL
   }

 }

 function getB2CTenantName () {
   if (window.location.hostname.includes('vendor')) {
     return process.env.VUE_APP_AZURE_US_TENANT_NAME;
   } else {
     return process.env.VUE_APP_AZURE_TENANT_NAME
   }
 }

  function getB2CTenantClient () {
   if (window.location.hostname.includes('vendor')) {
     return process.env.VUE_APP_AZURE_US_CLIENT_ID;
   } else {
     return process.env.VUE_APP_AZURE_CLIENT_ID
   }
 }

 function getB2cPolicyNames() {
   if (!window.location.origin.includes(process.env.VUE_APP_HAYS_URL_PREFIX)) {
     return {
       'sign_in': process.env.VUE_APP_AZURE_SIGN_IN_FLOW,
       'password': process.env.VUE_APP_AZURE_PASSWORD_FLOW,
       'profile': process.env.VUE_APP_AZURE_PROFILE_FLOW,
       'change_password': process.env.VUE_APP_AZURE_CHANGE_PASSWORD_FLOW
     }
   } else {
      return {
       'sign_in': process.env.VUE_APP_AZURE_SIGN_IN_FLOW_FREELANCERS,
       'password': process.env.VUE_APP_AZURE_PASSWORD_FLOW_FREELANCERS,
       'profile': process.env.VUE_APP_AZURE_PROFILE_FLOW_FREELANCERS,
       'change_password': process.env.VUE_APP_AZURE_CHANGE_PASSWORD_FLOW_FREELANCERS
     }
   }
 }

export default CONFIG;
